export const INACTIVITY_TIMEOUT = 1800000; // 30 minutes 30 * 60 * 1000 = 1,800,000 milliseconds
export const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'scroll', 'click']; // Events to track